export default __webpack_public_path__ + "img/334303264f5068f1b225badb1440e6d0.png";